export function fetchUserLocation({
  timeout = 15000,
}: { timeout?: number } = {}): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported by browser"));
      return;
    }
    const onSuccess: PositionCallback = async (location) => {
      resolve(location);
    };
    const onError: PositionErrorCallback = async (error) => {
      reject(error);
    };
    navigator.geolocation.getCurrentPosition(onSuccess, onError, {
      timeout,
      enableHighAccuracy: true,
    });
  });
}
